import { NextPageContext } from 'next';
import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../common/containers/TrackPageViewContainer';
import { t } from '../../common/getTranslations';
import { redirectInInitialProps } from '../../common/redirectInInitialProps';
import { Layout } from '../../design-system/layout/Layout';
import { CATEGORY_UID_TO_TITLE_MAP } from '../../domain/search/constant';
import { TodayGiftContainer } from '../../domain/today-gift/container/TodayGiftContainer';
import { ApiErrorBoundary } from '../../errors/ApiErrorBoundary.class';
import { CommonMobileHeaderType } from '../../header/constants';
import { ReactQueryFetcher } from '../../reactQuery/ReactQueryFetcher';
import { useTodayGiftListQuery } from '../../wrapper';
function TodayGift({
  categoryUid,
  subCategoryUid
}: {
  categoryUid: string;
  subCategoryUid?: string;
}) {
  return <>
      <ApiErrorBoundary>
        <ReactQueryFetcher reactQuery={useTodayGiftListQuery} variables={{
        categoryUid,
        subCategoryUid
      }} options={{
        refetchOnMount: true
      }}>
          {data => <TodayGiftContainer data={data} categoryUid={categoryUid} subCategoryUid={subCategoryUid} categoryList={data.todayGiftList?.categoryList ?? []} />}
        </ReactQueryFetcher>
      </ApiErrorBoundary>
      <TrackPageViewContainer trackObj={{
      section: '선물함',
      page: `선물함_${CATEGORY_UID_TO_TITLE_MAP[categoryUid]}`,
      actionType: 'Pageview',
      actionName: `선물함_${CATEGORY_UID_TO_TITLE_MAP[categoryUid]}_화면`,
      customProps: {
        user_action: 'pv'
      }
    }} />
    </>;
}
TodayGift.getInitialProps = async (context: NextPageContext) => {
  const categoryUidInfo = context.query?.pathParams as string[];
  if (!categoryUidInfo || categoryUidInfo.length === 0) {
    redirectInInitialProps({
      destination: '/today-gift/0',
      res: context.res
    });
    return {};
  }
  return {
    categoryUid: categoryUidInfo[0],
    subCategoryUid: context.query.subcategory_uid
  };
};
TodayGift.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('common_tab_giftbox')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.TwoDepth,
    headerCustomTiaraObject: {
      click: {
        layer1: '네비게이션'
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true
  }}>
      {page}
    </Layout>;
};
export default TodayGift;